import { TableAlignment } from '../types/alignment'

export const alignmentToJustify: Record<TableAlignment, string> = {
  center: 'center',
  left: 'flex-start',
  right: 'flex-end',
}
